import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserProfileModel } from './profile.model';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ProfileService {
    constructor(private http: HttpClient) { }

    user : UserProfileModel = new UserProfileModel();
    userInfo = new BehaviorSubject(this.user);
    currentUser = this.userInfo.asObservable();

    getUserProfile(): Observable<UserProfileModel> {
        const url = environment.url + 'User/profile';
        return this.http.get(url).pipe(map((response: UserProfileModel) => {
            this.updateUserInfo(response);
            return response;
        }));
    }

    updateUserInfo(data: UserProfileModel) {
        this.userInfo.next(data)
    }


    updateUserProfile(data): Observable<any> {
        const url = environment.url + 'User';
        return this.http.put(url, data).pipe(map((response: any) => {
            return response;
        }));
    }

    updateProfilePic(data): Observable<any> {
        const url = environment.url + 'User/upload-profile-pic';
        return this.http.put(url, data).pipe(map((response: any) => {
            return response;
        }));
    }


}
